(function() {
  // Run immediately when loaded
  if (window.location.href.indexOf('/orders') > -1 || 
      window.location.href.indexOf('account.bobbyjarvisjr') > -1) {
    
    console.log("Order page detected, adding banner");
    
    // Create a more prominent banner with !important styles
    var banner = document.createElement('div');
    banner.id = "portal-banner";
    banner.setAttribute('style', 'position: fixed !important; top: 0 !important; left: 0 !important; width: 100% !important; background-color: #ff6600 !important; color: white !important; padding: 20px !important; text-align: center !important; font-size: 18px !important; font-weight: bold !important; z-index: 999999 !important; box-shadow: 0 2px 10px rgba(0,0,0,0.3) !important;');
    
    // Use innerHTML for more reliable content insertion
    banner.innerHTML = '<div>⚠️ THIS IS NOT YOUR GUITAR LESSONS! ⚠️<br>Your lessons are in your Portal</div>' + 
                      '<a href="https://www.bobbyjarvisjr.com/pages/portal" ' +
                      'style="display: inline-block; background: white !important; color: #ff6600 !important; ' +
                      'padding: 10px 25px !important; margin: 10px auto !important; border-radius: 4px !important; ' +
                      'text-decoration: none !important; font-weight: bold !important; font-size: 16px !important;">CLICK HERE TO GO TO YOUR PORTAL →</a>';
    
    // Function to insert the banner that tries multiple methods
    function insertBanner() {
      // Try immediate insertion
      document.body.insertBefore(banner, document.body.firstChild);
      
      // Also add padding to body to prevent overlap
      document.body.style.paddingTop = '120px';
      document.body.style.marginTop = '120px';
    }
    
    // Try immediate insertion
    if (document.body) {
      insertBanner();
    } else {
      // If document.body isn't ready, wait for it
      document.addEventListener('DOMContentLoaded', insertBanner);
    }
    
    // Also try a delayed insertion as a backup
    setTimeout(function() {
      if (!document.getElementById('portal-banner')) {
        insertBanner();
      }
    }, 1000);
  }
})();